import React from 'react'
import classNames from 'classnames'
import {bool, shape, string} from 'prop-types'
import {ReactComponent as Logo} from '../../../../images/agillic_logo.svg'
import {extractInstanceProps} from '../../login.helper'
import EnvironmentLabel from '../../../../statelessComponents/environmentLabel/environmentLabel.presenter'
import localeData from '../../helpers/login.lang'
import {language} from '../../helpers/login.data'

const locale = localeData[language]

const Header = ({instanceProperties, isCollapsed}) => {
  const {prod, solutionName} = extractInstanceProps(instanceProperties)

  return (
    <header className={classNames('loginHeader', {isCollapsed})}>
      <Logo className='logo' />
      <div className={classNames('instanceInfo', {isStaging: !prod})}>
        <div className='solutionName'>
          {solutionName}
        </div>
        <EnvironmentLabel
          isProduction={prod}
          uniqueId='environmentLabel'
          size='medium'
          locale={{
            productionLabel: locale.production(),
            stagingLabel: locale.staging()
          }}
        />
      </div>
    </header>
  )
}

Header.propTypes = {
  instanceProperties: shape({
    type: string,
    name: string
  }),
  isCollapsed: bool
}

export default Header
